import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useParams, Link } from "react-router-dom";
import { HideShowShowStatus, deleteStatus, getcategorydata, gettokendata, updatecategory } from '../../actions/users';
import { toastAlert } from "../../lib/toastAlert";
import config from "../../lib/config"
import isEmpty from "../../lib/isEmpty"
import uploadimg from "../../assets/images/uploadimg.png";
import { Navigate, useNavigate } from 'react-router-dom';

const initialFormValue = {
    name: "",
    email: "",
    phonenumber: "",
    address1: "",
    address2: "",
    pincode: "",
    city: "",
    country: "",
    Photofile: "",
    BulkStatus: "false",
    BulkSubCategory: [],
    SubCategory: "",
    Collection: "Mint"
};

const EditCategory = () => {
    const navigate = useNavigate()
    const { userId } = useParams();
    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const [categoryurl, setImage] = React.useState(uploadimg);
    const [catdata, setcatdata] = useState("");
    const [BulkStatusVAl, SetBulkStatus] = useState("false");

    useEffect(() => {
        getCategoryData();
    }, []);
    const getCategoryData = async () => {
        var test = await getcategorydata(userId, "Mint");
        if (test.Success) {
            setcatdata(test.userValue.name)
            setImage(`${config.Back_Url}/admin/category/${test.userValue._id}/${test.userValue.image}`)
            SetBulkStatus(test.userValue.BulkStatus)
            setFormValue(test.userValue)
        }
    };

    const onChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: value } };
        setFormValue(formData);
    };

    const ShowHideSubCat = async (SubCat, CatName) => {
        var sendData = {
          name: CatName,
          SubcatStatus: SubCat.show == "true" || SubCat.show == true ? false : true,
          SubCatName: SubCat.name,
          Collection: "Mint"
        }
        var data = await HideShowShowStatus(sendData)
        if (data.Success) {
          toastAlert("success", "Status updated successfully")
        } else {
          toastAlert("error", "Failed to change Status.Try it again later")
        }
    }

    const handleFile = (e) => {
        e.preventDefault();
        const { id, files } = e.target;
        let formData = { ...formValue, ...{ [id]: files[0] } }
        setFormValue(formData)
        var validExtensions = ["png", 'gif', 'webp', 'PNG', 'jpg', 'jpeg', 'GIF', 'JPEG', 'JPG']; //array of valid extensions
        if (e.target && e.target.files) {
          var reader = new FileReader()
          var file = e.target.files[0];
          var fileName = file.name;
          var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
          if (!validExtensions.includes(String(fileNameExt))) {
            toastAlert("error", "Only these file types are accepted : " + validExtensions.join(', '));
            return false;
          }
          const fileSize = file.size;
          if (15000000 < fileSize) {
            toastAlert("error", "File size exceeds 15 MB");
            return false;
          }
          else {
            var url = reader.readAsDataURL(file);
            reader.onloadend = function (e) {
              if (reader.result) {
                setImage(reader.result);
              }
            }.bind(this);
          }
        }
      };
    
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        var name = catdata;
        let reqData = {
          name,
          Photofile,
          userId,
          BulkSubCategory,
          SubCategory,
          Collection
        };
        if (SubCategory == undefined || SubCategory == "") {
          toastAlert("error", "Enter SubCategory")
        } else {
          const { error } = await updatecategory(reqData);
          if (isEmpty(error)) {
            toastAlert("success", "Category details updated successfully");
            setTimeout(
              () => (window.location.href = "/categorylist"),
              1000
            );
          } else {
            setValidateError(error);
          }
    
        }
    };

    const { name, Photofile, BulkStatus, BulkSubCategory, SubCategory, Collection } = formValue;
    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Update Category'} />
                        <div className='common_page_scroller mt-5 pe-2'>
                        <div>
                              <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>
                            </div>
                            <form
                                noValidate
                            >
                                  <div color="primary" className="addcategorys">
                                    <h4>Update Category</h4>
                                </div>
                                <div className="categorylisdt">
                                <div className='row'>
                                  <div className='col-xl-5 mt-4'>
                                        <label htmlFor="category-name">Category Name</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            id="category-name"
                                            value={catdata}
                                            disabled
                                            fullWidth
                                        />
                                        {validateError.name && (
                                            <span className="text-danger">{validateError.name}</span>
                                        )}
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        
                                            <label htmlFor="file-input" className='mb-2'>Choose Image</label>
                                            <input
                                                type="file"
                                                className='form-control'
                                                id="file-input"
                                                onChange={handleFile}
                                                fullWidth
                                            />
                                            <label className='mb-2 mt-3'>Image Preview</label> <br></br>
                                            <img src={categoryurl} alt="category image" style={{ maxHeight: 100, maxWidth: 100 }} />
                                        
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="sub-category-name">Sub Category Name</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            id="SubCategory"
                                            value={SubCategory}
                                            onChange={onChange}
                                            fullWidth
                                        />
                                    </div>
                                    {formValue.BulkSubCategory.length > 0 &&
                                        formValue.BulkSubCategory.map((item) => (
                                            <div className='col-xl-5 mt-4' key={item.name}>
                                                <input
                                                    type="text"
                                                     className='form-control'
                                                    value={item.name}
                                                    disabled
                                                    fullWidth
                                                />
                                                {validateError.name && (
                                                    <span className="text-danger">{validateError.name}</span>
                                                )}
                                                <button
                                                  className='btn addcate py-2 px-3 mt-3'
                                                    type="button"
                                                    onClick={() => ShowHideSubCat(item, catdata)}
                                                >
                                                    {item.show === false || item.show === "false" ? "Show" : "Hide"}
                                                </button>
                                            </div>
                                        ))
                                    }
                                </div>
                                </div>
                                <div className='ms-2'>
                                    <button type="submit" className='btn addcate mt-4' onClick={handleFormSubmit}>
                                        Update
                                    </button>
                                </div>
                            </form>

                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default EditCategory